import { Mobile } from '@bimser/common';
import { FormItemTypes, IDictionary, MLHelper, createGuid, isNullOrUndefined } from '@bimser/core';
import { convertValue } from '..';
import DataGrid from '../..';
import {
	ICreateFormArgs,
	IDataGridColumnCollection,
	IExecuteActionButton,
	IOpenFormArgs,
	IOpenProcessArgs,
	IStartAProcessArgs
} from '../../../../../../entities';
import {
	IBaseExecuteActionArgs,
	ParameterItemType
} from '../../../../../../entities/common/executeActionArgs';
import { IUserEvent } from '../../../../../../entities/services';
import {
	IActionButtonClickEventArgs,
	IBeforeToolbarButtonClickEventArgs,
	IToolbarButtonClickEventArgs
} from '../../../../entities/EventArgs';
import ContextMenu from '../../../ContextMenu';
import { IActionButtonClickRowColumn, IDataGridRowCollection } from '../../entities';

import _get from 'lodash/get';

function getCommandColumnButtonArgs(
	this: DataGrid,
	props: IExecuteActionButton<any>,
	row: any,
	castedArgs: any
) {
	switch (props.typeName) {
		case 'CreateFormArgs': {
			castedArgs = { ...(props.args as ICreateFormArgs) };
			castedArgs.formName = convertValue(castedArgs.formName, row);
			castedArgs.formName = convertValue(castedArgs.formName, row);
			castedArgs.projectName = convertValue(castedArgs.projectName, row);
			break;
		}
		case 'OpenFormArgs': {
			castedArgs = { ...(props.args as IOpenFormArgs) };
			castedArgs.documentId = convertValue(castedArgs.documentId, row);
			break;
		}
		case 'OpenProcessArgs': {
			castedArgs = { ...(props.args as IOpenProcessArgs) };
			castedArgs.processId = convertValue(castedArgs.processId, row);
			castedArgs.processRequestId = convertValue(castedArgs.processRequestId, row);
			break;
		}
		case 'StartAProcessArgs': {
			castedArgs = { ...(props.args as IStartAProcessArgs) };
			castedArgs.flowName = convertValue(castedArgs.flowName, row);
			castedArgs.projectName = convertValue(castedArgs.projectName, row);
			break;
		}
	}
	return castedArgs;
}

function convertActionButtonParameterValues(
	this: DataGrid,
	args: IBaseExecuteActionArgs<ParameterItemType>,
	row?: IDictionary<any>
) {
	args.parameters?.forEach(param => {
		switch (param.type) {
			case 'column': {
				param._value = _get(row, param.value);
				break;
			}
			case 'field': {
				param._value = _get(this.__form, param.value);

				if (param._value == undefined) {
					const [controlName, field, columnName] = param.value.split('.');

					if (
						columnName &&
						(field === 'rows' || field === 'columns') &&
						this.__form[controlName].controlType == FormItemTypes.EControlTypes.DataGrid
					) {
						const rows: IDataGridRowCollection = _get(
							this.__form,
							`${controlName}.rows`
						);

						param._value = rows.map(
							row => row.cells.find(cell => cell.name == columnName).value
						);
					}
				}
				break;
			}
			case 'selectedRow': {
				const selectedRow = this.rows.find(r => r.selected);
				if (selectedRow?.data && param.value) {
					param._value = selectedRow.data[param.value];
				}
				break;
			}
		}
	});

	return args;
}

async function onColumnButtonClick(this: DataGrid, args: any, column: any) {
	const row: IActionButtonClickRowColumn[] =
		Object.keys(args.row)?.map(columnName => {
			const col = this.columns.find(c => c.name === columnName);
			let text = null,
				value = null;
			if (!isNullOrUndefined(args.row[columnName]) && args.row[columnName] !== '' && col) {
				switch (col?.editType) {
					case 'comboBox': {
						text = args.row[columnName].text;
						value = args.row[columnName].value;
						break;
					}
					case 'multiLanguageTextBox': {
						text = MLHelper.getMLText(args.row[columnName]);
						value = MLHelper.getMLText(args.row[columnName]);
						break;
					}
					case 'dateRangePicker': {
						const startDate = args.row[columnName][0] || '';
						const endDate = args.row[columnName][1] || '';
						text = `${startDate} / ${endDate}`;
						value = args.row[columnName];
						break;
					}
					default: {
						text = args.row[columnName];
						value = args.row[columnName];
					}
				}
				return { name: columnName, text, value };
			}

			return { name: columnName, text: null, value: null };
		}) || [];

	const argument: IActionButtonClickEventArgs = {
		name: column.name,
		row
	};

	const result = await this.__form.__runServerEvent({
		argument,
		controlId: this.name,
		name: 'ActionButtonClick',
		sender: 'web'
	});

	this.__form.__executedServerEvent = result.executedServerEvent;

	if (result.loadActionData.isDMFileSecretModified) {
		this.__form.__loadDocumentViewer();
	}

	if (result.loadActionData.isRDFileSecretModified) {
		this.__form.isLoadingRDObjects = false;
		this.__form.__getRDObjects();
	}

	const resultColumn: IDataGridColumnCollection = _get(
		result.loadActionData,
		['items', 'entities', 'items', this.name, 'properties', 'columns'],
		null
	)?.find(i => i.name === column.name);

	const castedArgs: any = getCommandColumnButtonArgs.call(
		this,
		column.actionButtonProps,
		args.row,
		column.actionButtonProps.args
	);

	if (
		castedArgs?.showOn &&
		this.__form.__fromMobile &&
		this.__form.__mobileFormView === Mobile.MobileFormView.NativePlus
	) {
		castedArgs.showOn = 'panel';
	}

	column.actionButtonProps.args = convertActionButtonParameterValues.call(
		this,
		column.actionButtonProps.args,
		args.row
	);

	onActionButtonClick.call(this, {
		...column.actionButtonProps,
		args: {
			...castedArgs,
			secretKey: _get(resultColumn, ['actionButtonProps', 'args', 'secretKey'], null)
		}
	});

	this.emit<IActionButtonClickEventArgs>('event:OnActionButtonClick', argument);
}

async function onBeforeToolbarItemClick(this: DataGrid, item: IExecuteActionButton<any>) {
	const beforeArgs: IBeforeToolbarButtonClickEventArgs = {
		cancel: false,
		name: item.name
	};

	await this.emit('event:OnBeforeToolbarButtonClick', beforeArgs);

	if (!beforeArgs.cancel) {
		onToolbarItemClick.call(this, item);
	}
}

async function onToolbarItemClick(this: DataGrid, item: IExecuteActionButton<any>) {
	item.args = convertActionButtonParameterValues.call(this, item.args);

	onActionButtonClick.call(this, item);

	this.emit<IToolbarButtonClickEventArgs>('event:OnToolbarButtonClick', { name: item.name });
	this.emit<IUserEvent<IToolbarButtonClickEventArgs>>('event:server:OnToolbarButtonClick', {
		argument: { name: item.name },
		controlId: this.name,
		name: 'OnToolbarButtonClick',
		sender: 'web',
		guid: createGuid()
	});
}

function onActionButtonClick(this: DataGrid | ContextMenu, item: IExecuteActionButton<any>) {
	switch (item.typeName) {
		case 'CreateFormArgs': {
			this.__form.createForm(item.args as ICreateFormArgs, this.name);
			break;
		}
		case 'OpenFormArgs': {
			if ((this as DataGrid).readOnly) {
				item.args.readOnly = true;
			}

			this.__form.openForm(item.args as IOpenFormArgs, this.name);
			break;
		}
		case 'OpenProcessArgs': {
			this.__form.openProcess(item.args as IOpenProcessArgs, this.name);
			break;
		}
		case 'OpenSelectionFormArgs': {
			if ((this as DataGrid).columns?.length) {
				item.args.targetDataGridColumns = (this as DataGrid).columns;
			}
			item.args.gridId = `runtime_${this.__form.projectName}_${this.__form.formName}_${this.__form.activeView}_${this.name}_${item.name}`;
			this.__form.openSelectionForm(item.args, this.name, item.title);
			break;
		}
		case 'StartAProcessArgs': {
			this.__form.startAProcess(item.args as IStartAProcessArgs, this.name);
			break;
		}
		case 'ExecuteCustomActionArgs':
			break;
		default:
			console.log('Execute action type not found!');
	}
}

export { onActionButtonClick, onBeforeToolbarItemClick, onColumnButtonClick };
